import $ from "jquery";
//############################
// Embed 360
//############################


function embedInit() {
    let dimensionSpan = $('#embed_dimension')
    let embedInitial = dimensionSpan.data('initial')
    let minSize = 50
    let maxSize = 640

    dimensionSpan.text(embedInitial)
    embedAdjustSize(embedInitial)

    // Embed slider handler - updated to HTML5 range input
    const embedSlider = $('.embed-size .slider input[type="range"]')

    embedSlider.on('input', function () {
        const value = parseInt(this.value)
        embedAdjustSize(value)
        dimensionSpan.text(value)
    })

    embedSlider.on('change', function () {
        const value = parseInt(this.value)
        $.post('/integrate/last_embed_size', { last_embed_size: value })
    })

    // Copy functionality for embed codes
    $('.input-group.readonly').on('click', function () {
        const input = $(this).find('input').get(0)
        const textToCopy = input.value

        // Select the text
        input.select()
        input.setSelectionRange(0, 99999) // For mobile devices

        // Try modern clipboard API first
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(textToCopy).then(() => {
                showCopyFeedback($(this))
            }).catch(err => {
                console.log('Clipboard API failed, falling back to execCommand:', err)
                fallbackCopyTextToClipboard(textToCopy, $(this))
            })
        } else {
            // Fallback for non-secure contexts or older browsers
            fallbackCopyTextToClipboard(textToCopy, $(this))
        }
    })

}

// Make embedInit globally available
window.embedInit = embedInit;

// Fallback copy function using execCommand
function fallbackCopyTextToClipboard(text, element) {
    const textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'
    textArea.style.opacity = '0'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        const successful = document.execCommand('copy')
        if (successful) {
            showCopyFeedback(element)
        } else {
            console.log('Fallback copy failed')
        }
    } catch (err) {
        console.error('Fallback copy failed:', err)
    }

    document.body.removeChild(textArea)
}

// Show visual feedback for successful copy
function showCopyFeedback(element) {
    const icon = element.find('.bi').first()
    if (icon.length === 0) return

    // Revert all other copy icons immediately
    $('.input-group.readonly .bi').each(function () {
        const other = $(this)
        if (other.is(icon)) return
        const storedOriginalOther = other.data('originalClass')
        const revertTo = storedOriginalOther || 'bi bi-clipboard-fill'
        const pendingOther = other.data('revertTimer')
        if (pendingOther) {
            clearTimeout(pendingOther)
            other.removeData('revertTimer')
        }
        other.attr('class', revertTo)
    })

    // Persist original classes once
    const storedOriginal = icon.data('originalClass')
    const originalClass = storedOriginal || icon.attr('class')
    if (!storedOriginal && originalClass) icon.data('originalClass', originalClass)

    // Clear any pending revert from a prior click
    const pending = icon.data('revertTimer')
    if (pending) {
        clearTimeout(pending)
        icon.removeData('revertTimer')
    }

    // Show green check
    icon.attr('class', 'bi bi-check-lg text-success')

    // Revert after 2 seconds
    const timerId = setTimeout(() => {
        if (originalClass) icon.attr('class', originalClass)
        icon.removeData('revertTimer')
    }, 2000)
    icon.data('revertTimer', timerId)
}



function embedAdjustSize(value) {
    $('input[data-embeddable=true]').each(function () {
        const input = $(this)
        let width = parseInt(input.data('width'))
        let height = parseInt(input.data('width'))
        const aspect_ratio = height / width

        if (aspect_ratio > 1) {
            height = value;
            width = Math.round(height / aspect_ratio);
        } else {
            width = value;
            height = Math.round(width * aspect_ratio);
        }

        let padding = Math.round(aspect_ratio * 100 * 100) / 100

        let html = $(this).data('value')
        html = html.replace(/\[width\]/g, width)
        html = html.replace(/\[height\]/g, height)
        html = html.replace(/\[padding\]/g, padding)

        input.attr('value', html)
    });
}





